import React, { useEffect, useRef, useState } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import FormControl from "@mui/material/FormControl";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Stack,
} from "@mui/material";

import { decryptPayload, getObjLength } from "../../helpers/utils";
import {
  canUseParcelSearch,
  getEnhancedMonitoringUnavailableMessage,
  setPropertySearchModeFromPayload,
} from "../../helpers/enhancedMonitoringSearchRules";
import { getEldoradoCountyRestrictionMessage } from "../../helpers/eldoradoSignup";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import HubspotCookieBreakerInput from "../../common/HubspotCookieBreakerInput";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import CustomizedCheckbox from "../../common/customDesignedComponents/customCheckbox";
import FindPropertyByParcelV2 from "../../user-signup/SignupTaiwindComponents/FindPropertyByParcelV2";

import "../../user-signup/signup.scss";

const FieldStyle = {
  borderRadius: "3px",
};

const validationSchema = Yup.object().shape({
  parcel_number: Yup.string()
    //   .min(2, "Too Short!")
    //   .max(15, "Too Long!")
    .required("Parcel number is required"),
  county_code: Yup.string("Please select the County ").required(
    "County  is required",
  ),
});

export default function FindPropertyByParcel({
  onBtnClick,
  onChangeModalScreen,
  isByPassOptionAvailable = false,
  isAdminCreateUser = false,
  isServiceProvider = false,
  onCloseModalHandler = () => {},
  setShowPropertyListing,
  propertyValues,
  setPropertyValues,
  setQuestionsErrMsg,
  questionsErrMsg,
  setErrMsg,
  errMsg,
  handleClose,
  validate,
  handleToggle,
  handleResponseModalOpen,
  editProperty = false,
  isAssistant = false,
  backToCategoryWisePricingScreen = () => {},
  isAdmin = false,
  userEmail = undefined,
  isTailwindComponent = false,
  hasSearched = false,
  propertyQuestion = {},
  isPropertyConfirmed = null,
  agreementCategory = undefined,
  category = undefined,
  categoryChosenBeforeSearch = false,
}) {
  const dispatch = useDispatch();
  const resolvedCategory =
    agreementCategory ||
    category ||
    decryptPayload(localStorage.getItem("category")) ||
    "complete_protection";
  const parcelSearchAllowed = canUseParcelSearch(resolvedCategory, {
    categoryChosenBeforeSearch,
  });

  const [open, setOpen] = useState(false);
  // const userIdFromSession = JSON.parse(localStorage.getItem("user_Id"));
  const [options, setOptions] = useState([]);
  const [editAdd, setEditAdd] = useState({});
  const countyDebounceRef = useRef(null);
  const COUNTY_SEARCH_DEBOUNCE_MS = 400;
  const { countyList, statesLoader } = useSelector((state) => state.signUpUser);

  const { getPropertyData, editPropertiesDetails } = useSelector(
    (state) => state.properties,
  );

  const { verifiedPropertiesList } = useSelector((state) => state.signUpUser);

  const onSubmit = (values, errors) => {
    if (!parcelSearchAllowed) {
      return;
    }
    let data = { ...values, type: "parcel" };
    console.log("submited values==>", data);

    const eldoradoRestrictionMessage = getEldoradoCountyRestrictionMessage({
      county: data?.county_name || data?.county,
      county_name: data?.county_name || data?.county,
      county_code: data?.county_code,
      county_id: data?.county_id,
    });
    if (eldoradoRestrictionMessage) {
      setErrMsg(eldoradoRestrictionMessage);
      return;
    }

    setErrMsg("");
    setPropertySearchModeFromPayload(data);
    if (typeof handleToggle === "function") {
      handleToggle();
    }
    dispatch(
      propertiesAction.fetchUserProperty({
        url: "properties",
        data: data,
        token: false,
      }),
    );
    // onBtnClick();
  };

  const getCountyList = (countyValue, immediate = false) => {
    if (countyDebounceRef.current) {
      clearTimeout(countyDebounceRef.current);
      countyDebounceRef.current = null;
    }

    const query = String(countyValue || "").trim();
    const runSearch = () => {
      dispatch(
        userSigupAction.getCountyList({
          url: "get-county-autocomplete",
          data: { county: query },
        }),
      );
    };

    if (immediate) {
      if (query) {
        runSearch();
      }
      return;
    }

    if (query.length < 3) {
      return;
    }

    countyDebounceRef.current = setTimeout(runSearch, COUNTY_SEARCH_DEBOUNCE_MS);
  };

  useEffect(() => {
    return () => {
      if (countyDebounceRef.current) {
        clearTimeout(countyDebounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (editProperty) {
      console.log(editAdd?.county_code, "editProperty==>", editProperty);
      getCountyList(editPropertiesDetails?.data?.county_code, true);
    }
  }, []);
  useEffect(() => {
    if (getObjLength(countyList)) {
      console.log(countyList, "options==>", options);
      if (countyList?.success) {
        if (countyList?.data?.length > 0) {
          setOptions([...countyList.data]);
        }
      }
    }
  }, [countyList]);
  console.log(countyList, "ssss--- options==>", options);

  useEffect(() => {
    if (getObjLength(getPropertyData)) {
      if (getPropertyData?.success) {
        setPropertyValues(getPropertyData?.data);
        setErrMsg("");
        if (getPropertyData?.data?.length === 1) {
          dispatch(
            propertiesAction.selectedUserPropertyData(getPropertyData?.data[0]),
          );
        }
        if (getPropertyData?.data?.length > 1) {
          setOptions([]);
          setShowPropertyListing(true);
          console.log("setPropertyValues ==>", getPropertyData);
        }
      } else {
        setPropertyValues({});
        setErrMsg(
          getPropertyData?.data?.message ||
            getPropertyData?.message ||
            "No property found for that search.",
        );
        if (typeof handleClose === "function") {
          handleClose();
        }
      }
    }
  }, [getPropertyData]);

  useEffect(() => {
    if (getObjLength(editPropertiesDetails)) {
      if (editPropertiesDetails?.success && editProperty) {
        setEditAdd(editPropertiesDetails?.data);
      }
    }
  }, [editPropertiesDetails, editProperty]);

  return (
    <>
      {isTailwindComponent ? (
        <FindPropertyByParcelV2
          agreementCategory={agreementCategory}
          category={category || resolvedCategory}
          categoryChosenBeforeSearch={categoryChosenBeforeSearch}
          onSubmit={onSubmit}
          propertyValues={propertyValues}
          errMsg={errMsg}
          questionsErrMsg={questionsErrMsg}
          // setChecked1={setChecked1}
          hasSearched={hasSearched}
          onBtnClick={onBtnClick}
          isPropertyConfirmed={isPropertyConfirmed}
          propertyQuestion={propertyQuestion}
          isByPassOptionAvailable={isByPassOptionAvailable}
          isAdminCreateUser={isAdminCreateUser}
          isServiceProvider={isServiceProvider}
          isAssistant={isAssistant}
        />
      ) : !parcelSearchAllowed ? (
        <Box mt={3} className="findPropertyBoxWrapper ">
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={6} px={1} pb={1}>
              <TextField
                className="sign-textField"
                label="Parcel Number"
                name="parcel_number"
                value=""
                disabled
                variant="outlined"
                sx={FieldStyle}
                placeholder="Parcel Number"
              />
            </Grid>
            <Grid item xs={12} md={6} px={1} pb={1}>
              <TextField
                className="sign-textField"
                label="County"
                name="county_code"
                value=""
                disabled
                variant="outlined"
                sx={FieldStyle}
                placeholder="Search the County"
              />
            </Grid>
          </Grid>
          <p
            style={{
              color: "#666",
              fontSize: 14,
              lineHeight: 1.5,
              marginTop: 12,
            }}
          >
            {getEnhancedMonitoringUnavailableMessage()}
          </p>
        </Box>
      ) : (
        <Box>
          {
            <>
              <>
                <>
                  <Box mt={3} className="findPropertyBoxWrapper ">
                    <Formik
                      enableReinitialize
                      validateOnChange
                      initialValues={{
                        parcel_number:
                          (editProperty ? editAdd?.parcel_number : "") || "",
                        county_code:
                          (editProperty ? editAdd?.county_code : "") || "",
                        county_name:
                          (editProperty ? editAdd?.county_name : "") || "",
                      }}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {({ values, setFieldValue, touched, errors }) => {
                        return (
                          <Form id="find-property-by-parcel-form">
                            {/* Hubspot hidden input for cookie breaker */}
                            <HubspotCookieBreakerInput
                              userEmail={userEmail}
                              isPropertyForm={true}
                            />

                            <Grid
                              container
                              rowSpacing={1}
                              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            >
                              <Grid item xs={12} md={6} px={1} pb={1}>
                                <TextField
                                  // fullWidth
                                  className="sign-textField"
                                  id="parcelNumberField"
                                  label="Parcel Number"
                                  name="parcel_number"
                                  // type="number"
                                  // onKeyDown={(e) => {
                                  //   // if (!e.key.match(/[A-Za-z]*$/)?.length > 0) {
                                  //   //   e.preventDefault();
                                  //   // }
                                  //   // var x = e.which || e.keycode;
                                  //   if (!e.key.match(/[A-Za-z]*$/)?.length > 0) {
                                  //     e.preventDefault();
                                  //   }
                                  // }}
                                  value={values?.parcel_number}
                                  variant="outlined"
                                  sx={FieldStyle}
                                  InputLabelProps={{
                                    style: {
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      lineHeight: "20px",
                                      color: "#0D120B",
                                    },
                                  }}
                                  onChange={(event) => {
                                    setFieldValue(
                                      "parcel_number",
                                      event.target.value,
                                    );
                                  }}
                                  helperText={
                                    touched.parcel_number &&
                                    errors.parcel_number
                                  }
                                  error={
                                    touched.parcel_number &&
                                    Boolean(errors.parcel_number)
                                  }
                                />
                              </Grid>

                              <Grid item xs={12} md={6} px={1} pb={1}>
                                <FormControl
                                  fullWidth
                                  className="sign-textField"
                                  htmlFor="demo-customized-textbox"
                                  error={
                                    touched.county_code &&
                                    Boolean(errors.county_code)
                                  }
                                >
                                  <Autocomplete
                                    // name="county_code"
                                    id="countyCodeField"
                                    // freeSolo
                                    disableClearable
                                    sx={FieldStyle}
                                    open={open || statesLoader}
                                    onOpen={() => {
                                      setOpen(true);
                                    }}
                                    onClose={() => {
                                      if (!statesLoader) {
                                        setOpen(false);
                                      }
                                    }}
                                    onChange={(event, newValue) => {
                                      setFieldValue(
                                        "county_code",
                                        String(newValue?.id),
                                      );
                                      setFieldValue(
                                        "county_name",
                                        newValue?.county || "",
                                      );
                                      setErrMsg("");
                                    }}
                                    isOptionEqualToValue={(option, value) =>
                                      option.county === value.county
                                    }
                                    getOptionLabel={(option) =>
                                      option.county || values.county_code
                                    }
                                    options={options}
                                    loading={statesLoader}
                                    componentsProps={{
                                      popper: {
                                        //placement: "top-start",
                                        modifiers: [
                                          { name: "flip", enabled: true },
                                          {
                                            name: "preventOverflow",
                                            options: {
                                              altBoundary: true,
                                              rootBoundary: "viewport",
                                            },
                                          },
                                        ],
                                      },
                                      listbox: {
                                        style: {
                                          maxHeight: "40vh",
                                          overflow: "auto",
                                        },
                                      },
                                      paper: {
                                        style: {
                                          maxHeight: "40vh",
                                          overflow: "auto",
                                          zIndex: 1600,
                                        },
                                      },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        onChange={(event) => {
                                          getCountyList(event.target.value);
                                          if (event.target.value.length >= 3) {
                                            setOpen(true);
                                          }
                                        }}
                                        label="County"
                                        placeholder={"Search the County"}
                                        {...params}
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <React.Fragment>
                                              {statesLoader ? (
                                                <CircularProgress
                                                  color="inherit"
                                                  size={20}
                                                />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </React.Fragment>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                  {touched.county_code &&
                                    Boolean(errors.county_code) && (
                                      <FormHelperText
                                        sx={{ color: "#d32f2f !important" }}
                                      >
                                        {touched.county_code &&
                                          errors.county_code}
                                      </FormHelperText>
                                    )}
                                </FormControl>
                              </Grid>

                              {isByPassOptionAvailable &&
                                !isAssistant &&
                                !(isServiceProvider && isAdminCreateUser) && (
                                  <>
                                    <Grid xs={12} md={12} px={1} pb={1}>
                                      <Stack
                                        direction={"row"}
                                        spacing={1}
                                        justifyContent={"flex-start"}
                                        alignItems={"center"}
                                      >
                                        <span className="pt-0">
                                          <CustomizedCheckbox
                                            onChecked={(e) => {
                                              dispatch(
                                                propertiesAction.setIsQuestionByPass(
                                                  e.target.checked,
                                                ),
                                              );
                                              // setIsQuestionByPass(e.target.checked);
                                            }}
                                          />
                                        </span>
                                        <span>
                                          Do you want to bypass security
                                          questions for this property?
                                        </span>
                                      </Stack>
                                    </Grid>
                                  </>
                                )}
                              {errMsg && (
                                <p className="text-center text-danger mb-0">
                                  {errMsg}
                                </p>
                              )}
                            </Grid>
                            <div className="text-center stepBtn mt-5">
                              {isAdminCreateUser &&
                                verifiedPropertiesList?.data?.length > 0 && (
                                  <Button
                                    className=" other_popup_btn next_button mb-3 mx-2"
                                    variant="contained"
                                    onClick={() =>
                                      onCloseModalHandler("propertyList")
                                    }
                                  >
                                    Property List
                                  </Button>
                                )}
                              {isAdmin && (
                                <Button
                                  className=" other_popup_btn next_button mb-3 mx-2"
                                  variant="contained"
                                  onClick={() =>
                                    backToCategoryWisePricingScreen()
                                  }
                                >
                                  Back to Pricing
                                </Button>
                              )}

                              <Button
                                type="submit"
                                className="next_button mb-3"
                                variant="contained"
                              >
                                Next Step
                              </Button>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </Box>
                </>
              </>

              {questionsErrMsg?.length > 0 && (
                <p className="text-danger text-center">{questionsErrMsg}</p>
              )}
            </>
          }
        </Box>
      )}
      {/* <Loader open={propertyLoader} /> */}
    </>
  );
}
